// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kfmzvgnogwgtrkvtoalp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtmbXp2Z25vZ3dndHJrdnRvYWxwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE4NDg3OTEsImV4cCI6MjA4NzQyNDc5MX0.BBxlliuZMPUG6OulQj4YhC6urEosp5mb6Y1BQ0QOHMs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});